function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 52 65"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.76 54.443L43.978 38.42 15.216 10.415.325 53.045c-.312.887.557 1.733 1.435 1.398z",
  fill: "#FFCF61"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.978 38.42l-1.616-1.571L9.38 27.125l-2.185 6.257 28.178 8.306 8.606-3.267z",
  fill: "#E5B038"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.119 22.005l-14.463-4.263-3.279 9.384 32.986 9.723L27.12 22.005z",
  fill: "#FFCF61"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.216 10.414l-2.559 7.33 14.462 4.262-11.903-11.592z",
  fill: "#E5B038"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.021 47.514l15.35-5.827-28.177-8.305-3.28 9.382 16.107 4.75z",
  fill: "#FFCF61"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.275 47.457l10.07 2.97 7.677-2.914-16.108-4.748-1.639 4.692z",
  fill: "#E5B038"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.324 53.045c-.31.888.557 1.733 1.435 1.398l10.588-4.017-10.073-2.969-1.95 5.588z",
  fill: "#FFCF61"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "9",
  y: "9",
  width: "41",
  height: "31"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.507 19.355l-5.615 19.817L9.686 29.48 15.3 9.663l34.207 9.692z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.215 10.414c1.683-1.726 9.486 3.14 17.429 10.876 7.941 7.733 13.015 15.403 11.334 17.131-1.682 1.729-9.486-3.142-17.427-10.875-7.943-7.734-13.017-15.403-11.336-17.132z",
  fill: "#5F6C72"
})), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "52",
  height: "65"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.178.604L0 54.175l36.696 10.397L51.873 11 15.178.604z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.583 20.23l-1.103 3.892 3.892 1.102 1.102-3.892-3.891-1.102z",
  fill: "#ADD2FA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.58 18.707l-3.917 2.771 2.773 3.918 3.918-2.773-2.773-3.916z",
  fill: "#FD99C0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.4 9.676l-.239 3.91 5.585-.63.237-3.909-5.584.63z",
  fill: "#FFA38C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.347 4.169l-2.692 1.78 2.205 5.086 2.693-1.779-2.206-5.087z",
  fill: "#ADD2FA"
}))));